import React from 'react';
import { Shimmer } from '../Shimmer/Shimmer';
import { ShimmerSectionContainer } from './ODDDetailsShimmer.styles';

const SECTION_ROW_COUNTS = [5, 4, 7];

export const ODDDetailsShimmer: React.FC = () => (
  <>
    {SECTION_ROW_COUNTS.map((rowCount, sectionIndex) => (
      <ShimmerSectionContainer key={sectionIndex}>
        <div className="section-top-container">
          <Shimmer width={140} height={18} />
          <Shimmer width={32} height={18} />
        </div>
        <div className="section-top-container__info-container">
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <div key={rowIndex} className="info-container__row">
              <Shimmer width={120} height={16} />
              <Shimmer width={160} height={16} />
            </div>
          ))}
        </div>
      </ShimmerSectionContainer>
    ))}
  </>
);
